module.exports = __webpack_public_path__ + "static/media/varsity_vixens.3ccd9d12.jpg";